/**
 * Splits an array into fixed-size chunks without mutating the original array.
 * Throws when the requested chunk size is not a positive integer so that callers
 * can't accidentally disable batching.
 */
export function chunkArray<T>(items: T[], size: number): T[][] {
  if (!Number.isInteger(size) || size <= 0) {
    throw new Error(`chunkArray size must be a positive integer, received ${size}`);
  }

  const result: T[][] = [];
  for (let i = 0; i < items.length; i += size) {
    result.push(items.slice(i, i + size));
  }
  return result;
}
